import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { ApiService } from '../api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
import { ObservablesService } from '../observables.service';
import { _ } from 'underscore';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';

interface userNode {
  full_name: string;
  children?: userNode[];
}
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  busienessDetails:any=[];
  editStatus:boolean = false;
  editId:any='';
  closeResult: string;
  userForm: FormGroup;
  user_id:any;
  bussiness_name:any;
  loggedUserInfo:any=[];
  roles:any=[]
  parentRoles:any=[]
  users:any=[]
  TREE_DATA:userNode[]=[]
  activeItem:string=''
  treeControl = new NestedTreeControl<userNode>(node => node.children);
 dataSource = new MatTreeNestedDataSource<userNode>();
  constructor(private modalService: NgbModal,private observables:ObservablesService,
    private formBuilder: FormBuilder,private api:ApiService,private router: Router) {

    }
    hasChild = (_: number, node: userNode) => !!node.children && node.children.length > 0;

  ngOnInit() {
    this.createForm()
    // this.getBusinesses()
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        // this.h_level = Array(this.loggedUserInfo.h_level).fill(0).map((x,i)=>i+1);
        // this.getLoggedUserParties()
        this.getRoles();
        this.getUsers()
      }else{
        this.api.logOut()
      }
    })
  }

  showInput(node){
    // console.log("show node=",node)
    this.activeItem = node.id;
  }

  hideInput(node){
    // console.log("hide node=",node)
    if(node.id == this.activeItem){

      this.activeItem = '';
    }
  }

  saveNode(node, itemValue: string) {
    // console.log("node==",node);
    // console.log("itemValue==",itemValue);
    // console.log("this.dataSource.data.==",this.dataSource.data);
    // this.dataSource.data[0].children.map(item=>{
    //   if(item.party_id == option.client_id){
    //     if(option.status){
    //
    //       item.monthly_gst_complation_status_count = (option.checked)?parseInt(item.monthly_gst_complation_status_count)+1:item.monthly_gst_complation_status_count-1;
    //       item.ledger_completion_status = "1";
    //     }else{
    //       item.ledger_completion_status = (option.checked)?"1":"0";
    //     }
    //
    //   }
    // })
    this.api.send("insertDb",{
      table:'users',
      data:{
        business_id:this.loggedUserInfo.business_id,
        parent_id:node.id,
        role_id:node.level+1,
        full_name:itemValue
      }
    }).then((res:any)=>{
      if(res.data.affectedRows){
        this.getUsers()
      }else{

      }
    })
     // const nestedNode = this.flatNodeMap.get(node);
     // this._database.updateItem(nestedNode!, itemValue);
   }


  createForm(){
    this.userForm = this.formBuilder.group({
      role_id:[null, Validators.required],
      parent_id:[null, Validators.required],
      full_name:['', Validators.required],
      username:['', Validators.required],
      password:['', Validators.required],
      mobile:[null]
    });
  }



  getBusinesses(){

     this.api.send("findDb",{
       table:"businesses",
       conditions:[{id:2}]
     }).then((result:any)=>{
       this.busienessDetails=result.data[0]
       this.getRoles();
       this.getUsers()
     })
  }
  getRoles(){
    this.api.send("findDb",{
      table:"roles",
      conditions:[{business_id:this.loggedUserInfo.business_id, "role !":'ADMIN'}]
    }).then((result:any)=>{
      this.roles=result.data
    })
  }

  getUsers(){
    this.TREE_DATA= []
    this.api.send('findDb',{
      table:'users as U',
      fields:['U.id as id','U.full_name','U.username','U.mobile','R.role','R.level','R.is_last_level','U.role_id','U.parent_id'],
      joins:[{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
    }).then((result:any)=>{
      this.users=result.data
      // console.log("users=",this.users)
      var idToNodeMap = {};
      var root = null;
      var parentNode;
      for(var i = 0; i < this.users.length; i++) {
          var datum = this.users[i];
          datum.children = [];
          idToNodeMap[datum.id] = datum;

          if(!datum.parent_id) {
              root = datum;
          } else {
            // console.log("datum=",datum)
              parentNode = idToNodeMap[datum.parent_id];

              parentNode.children.push(datum);
          }
      }

      this.TREE_DATA.push(root)
      this.dataSource.data = this.TREE_DATA;
      // console.log("this.dataSource.data=",this.dataSource.data);

    })
  }

  roleSeleted(event){
    // console.log(event)
    this.api.send('findDb',{
      table:'users as U',
      fields:['U.id as user_id','U.full_name','R.role'],
      joins:[{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{"R.level IS < THAN":event.value, 'U.business_id':this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){

        this.parentRoles = res.data;
        // console.log('parent users=',this.parentRoles)
      }
    })
  }

  getSelecteRoleId(level){
    return new Promise((resolve)=>{
      for(let i=0;i<this.roles.length;i++){
        if(this.roles[i].level == level){
          resolve(this.roles[i].id)
        }
      }
    })
  }

  submitData(value,formDirective:FormGroupDirective){
    // console.log("roles=",this.roles)
    // console.log("user data=",value)
    this.getSelecteRoleId(value.role_id).then((role_id)=>{

      this.api.send("insertDb",{
        table:"users",
        data:{
          business_id:this.loggedUserInfo.business_id,
          role_id:role_id,
          parent_id:value.parent_id,
          full_name:value.full_name,
          username:value.username,
          password:value.password,
          mobile:value.mobile
        }
      }).then((result:any)=>{
        if(result.data.affectedRows){
          formDirective.resetForm();
          this.userForm.reset()
          this.getUsers();
          this.observables.showToastMessage({type:0, message:"User Added Successfully"})
        }else{

          this.observables.showToastMessage({type:1, message:"Some problem while adding User details, try again."})
        }
      })
    })
    // console.log("role_id data=",selectedRoleData.id)

  }

  cancel(formDirective:FormGroupDirective){
    formDirective.resetForm();
    this.userForm.reset();
    this.userForm.get('password').enable()
    this.editStatus = false;
    this.editId = ''
  }
  updateData(value,formDirective:FormGroupDirective){
    // console.log("values==",value)

    this.api.send("updateDb",{
      table:"users",
      data:{
        full_name:value.full_name,
        username:value.username,
        mobile:value.mobile,
        role_id:value.level,
        parent_id:value.parent_id
      },
      conditions:[{id:this.editId}]
    }).then((result:any)=>{
      if(result.data.affectedRows){
        formDirective.resetForm();
        this.userForm.reset()
        this.userForm.get('password').enable()
        this.getUsers();
        this.editStatus = false;
        this.editId = ''
        this.observables.showToastMessage({type:0, message:"User Updated Successfully"})
      }else{
        this.observables.showToastMessage({type:1, message:"Some problem while updating user details, try again."})
      }
    })
  }


  deleteUser(id){
    if(confirm("Are you sure want to delete user?")){

      this.api.send("deleteDb",{
        table:"users",
        conditions:[{id:id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.observables.showToastMessage({type:0, message:"User Deleted Successfully"})
          this.getUsers();
        }

      })
    }
  }

  editUser(user){
    // console.log("users==",user)
    this.roleSeleted({value:user.level})

    this.userForm.patchValue({
      full_name:user.full_name,
      username:user.username,
      password:"abcdefghijklmnopqrstuvwxyz",
      mobile:user.mobile,
      role_id:user.level,
      parent_id:user.parent_id
    });

    this.userForm.get('password').disable()

    this.editStatus = true;
    this.editId = user.id;
  }

}
